module.exports = __webpack_public_path__ + "media/categories/2044-e99eb221.svg";